// src/store/reducers/garageReducer.js
import { GARAGE_ACTION_TYPES } from '../actions/actionTypes';

const initialState = {
  garages: [],
  vehicleMakes : [],
  currentGarage: null,
  statistics: null,
  loading: false,
  error: null,
  success: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  importResult: null,
  recentReview: null,
};

export const garageReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch garages
    case GARAGE_ACTION_TYPES.FETCH_GARAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_GARAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        garages: action.payload.garages,
        pagination: action.payload.pagination,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_GARAGES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

          // Fetch vehicle makes
    case GARAGE_ACTION_TYPES.FETCH_MAKES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_MAKES_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicleMakes: action.payload,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_MAKES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Fetch single garage
    case GARAGE_ACTION_TYPES.FETCH_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentGarage: action.payload,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_GARAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    
    // Create garage
    case GARAGE_ACTION_TYPES.CREATE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.CREATE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        garages: [action.payload.garage, ...state.garages],
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.CREATE_GARAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
    
    // Update garage
    case GARAGE_ACTION_TYPES.UPDATE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.UPDATE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        garages: state.garages.map((g) =>
          g.id === action.payload.garage.id ? action.payload.garage : g
        ),
        currentGarage: action.payload.garage,
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.UPDATE_GARAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
    
    // Delete garage
    case GARAGE_ACTION_TYPES.DELETE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.DELETE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        garages: state.garages.filter((g) => g.id !== action.payload.id),
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.DELETE_GARAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
    
    // Update approval status
    case GARAGE_ACTION_TYPES.UPDATE_APPROVAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.UPDATE_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        garages: state.garages.map((g) =>
          g.id === action.payload.garage.id ? action.payload.garage : g
        ),
        currentGarage: action.payload.garage,
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.UPDATE_APPROVAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
    
    // Add review
    case GARAGE_ACTION_TYPES.ADD_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.ADD_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        recentReview: action.payload.review,
        currentGarage: state.currentGarage
          ? {
              ...state.currentGarage,
              reviews: [action.payload.review, ...(state.currentGarage.reviews || [])],
              rating: action.payload.review.rating, // Will be updated by backend
            }
          : null,
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.ADD_REVIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };
    
    // Bulk import
    case GARAGE_ACTION_TYPES.BULK_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        importResult: null,
      };
    
    case GARAGE_ACTION_TYPES.BULK_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        importResult: action.payload.result,
        success: action.payload.message,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.BULK_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
        importResult: null,
      };
    
    // Fetch statistics
    case GARAGE_ACTION_TYPES.FETCH_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.payload,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.FETCH_STATISTICS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    
    // Clear states
    case GARAGE_ACTION_TYPES.CLEAR_GARAGE_ERROR:
      return {
        ...state,
        error: null,
      };
    
    case GARAGE_ACTION_TYPES.CLEAR_GARAGE_SUCCESS:
      return {
        ...state,
        success: null,
      };
    
    case GARAGE_ACTION_TYPES.CLEAR_GARAGE_STATE:
      return initialState;
    
    default:
      return state;
  }
};